import emailjs from '@emailjs/browser';

const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY;
const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID;

// Initialize EmailJS
emailjs.init(PUBLIC_KEY);

export interface ContactFormData {
    name: string;
    email: string;
    subject: string;
    message: string;
}

export async function sendContactEmail(data: ContactFormData): Promise<void> {
    const templateParams = {
        from_name: data.name,
        from_email: data.email,
        subject: data.subject,
        message: data.message,
    };

    await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams);
}
